import STAYS from './stays/_settings'

const SETTINGS = {
  STAYS
}

export default SETTINGS
